package com.tfc.care.tfccare

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import coil3.compose.AsyncImage
import com.tfc.care.tfccare.ui.StaffApp
import com.tfc.care.tfccare.ui.StaffChatViewModel
import com.tfc.care.tfccare.ui.theme.AppTheme
import kotlinx.coroutines.launch
import org.koin.mp.KoinPlatform.getKoin

@Composable
fun App(userId: String?, password: String? ) {
    val viewModel: StaffChatViewModel = remember { getKoin().get() }
    val chatState by viewModel.chatState.collectAsState()


    LaunchedEffect(Unit) {
        if (!userId.isNullOrEmpty()  && !password.isNullOrEmpty() ) {
            viewModel.signIn(userId, password)
        }
    }

    AppTheme(darkTheme = chatState.isDarkTheme) {
        val scope = rememberCoroutineScope()
        val snackbarHostState = remember { SnackbarHostState() }

        Scaffold(
            snackbarHost = { SnackbarHost(snackbarHostState) }
        ) {
            StaffApp(
                showMessage = { m: String ->
                    scope.launch {
                        if (m.isNotEmpty()) {
                            val msg = m.split("@").firstOrNull()
                            snackbarHostState.showSnackbar(
                                message = msg ?: "",
                                actionLabel = if (m.contains("downloaded", true)) "Open" else "Dismiss",
                            )
                        }
                    }
                },
                viewModel = viewModel,
                onImagePick = {
                    pickImageFromBrowser { bytes ->
                        scope.launch {
                            try {
                                viewModel.sendImageMessage(bytes)
                            } catch (e: Exception) {
                                println("Error loading image: ${e.message}")
                            }
                        }

                    }
                },
                imageLoader = { url ->
                    AsyncImage(
                        model = url,
                        contentDescription = "Chat image",
                        modifier = Modifier.fillMaxSize(),
                        contentScale = ContentScale.Fit,
                        )
                }
            )
        }
    }
}
